/** @format */

//importing assets
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";

//importing Assets
import Pic from "../../Assets/images/ahmedEldesoky.png";
import { baneManager } from "../../services/managers";
import { alertMsg } from "../../utilities/helper";
import ActionModal from "../pops/global modals/action-modal";

export const UserCard = ({
  role,
  name,
  created,
  photo,
  condation,
  managerProfile,
  getManagerProfile,
}) => {
  const [isOpen, setOpen] = useState(false);
  let { id } = useParams();
  const dispatch = useDispatch();
  const handleBaneManager = () => {
    dispatch(
      baneManager({
        url: "/moderators/update-status/" + id,
        params: { status: "inactive" },
      })
    ).then((res) => {
      alertMsg("تم حظر المشرف بنجاح  ", true);
      getManagerProfile();
      setOpen(false);
    });
  };
  const handleActivetManager = () => {
    dispatch(
      baneManager({
        url: "/moderators/update-status/" + id,
        params: { status: "active" },
      })
    ).then((res) => {
      alertMsg("تم تفعيل المشرف بنجاح  ", true);
      getManagerProfile();
      setOpen(false);
    });
  };
  return (
    <div className='user-card-global'>
      <div className='user-card__side-right'>
        <div className='user-card__img-box'>
          <img
            src={photo ? photo : Pic}
            alt='profile '
            className='user-card__img'
          />
        </div>
        <div className='col-flex'>
          <h2 className='ternary__heading--mid '>{name ? name : "جاسم"}</h2>
          <h2 className='ternary__heading--mid text--primary'>
            {role ? role : "سائق"}{" "}
          </h2>
          <h2 className='text-gray text-gray--small'>
            {created ? created.slice(0, 10) : "12/10/2002"}{" "}
          </h2>
        </div>
      </div>
      {}
      {role === "سائق" ? (
        ""
      ) : (
        <div className='user-card__side-left'>
          <Link to='/manger-access'>
            <button className='btn btn__primary'>تعديل الصلاحيات </button>{" "}
          </Link>
          <button className='btn btn__danger' onClick={() => setOpen(true)}>
            {managerProfile.status === "active" ? "حظر المشرف" : "تفعيل المشرف"}{" "}
          </button>{" "}
          <ActionModal
            data={managerProfile}
            type={managerProfile.status === "active" ? "delete" : "activate"}
            showModal={isOpen}
            setShowModal={setOpen}
            msg={
              managerProfile.status === "active"
                ? "هل تريد حظر هذا المشرف ؟"
                : "هل تريد اعادة تفعيل هذا المشرف ؟"
            }
            action={
              managerProfile.status === "active"
                ? handleBaneManager
                : handleActivetManager
            }
          />
        </div>
      )}
    </div>
  );
};
